import { securityAuthenticationEnrollPostAsyncSlice } from './post';

export const {
	requestPostSecurityAuthenticationEnroll,
	resetPostSecurityAuthenticationEnroll
} = securityAuthenticationEnrollPostAsyncSlice.asyncActionCreators;
